(() => {
  // js/custom-element/custom-html-element.js
  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
      return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      var _a;
      this.delegate.destroy();
      this.rootDelegate.destroy();
      (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  //js/custom-element/section/product/glory-variants.js
  var GloryVariants = class extends CustomHTMLElement {
    constructor() {
      super();
      this.state = {
        selectedVariant: null, //glory
        selectedRayVariant: null, // solar
        selectedRayQty: 0, // solar
        product: null,
        rayProduct: null,
        rayLiteProduct: null,
        variants: [],
        rayVariants: [],
        rayLiteVariants: [],
        mountIndex: 0,
        mountType: '',
        panelWatt: '200W',        // '200W' | '200W_lite'
        panelCount: 4,            // number of boards (4x default)
        storageCount: 1,          // 1x default
        adjustable: 'before',
        hideSoldOut: this.hasAttribute('hide-sold-out-variants'),
        prodIndex: null,           // 1-based prod_index from data-prod-index
        bracketVariantId: null,
        storageVariantId: null,
        bracketPrice: null,
        bracketCompare: null,
        storagePrice: null,
        storageCompare: null,
        addons: [],
        activeTab: 'custom',
        bundle: null,
        taxConfirmed: false,
        pendingBuyNow: false
      };
    }

    connectedCallback() {
      this._sectionRoot = this.closest('[id^="shopify-section-"]') || document;

      // Listen for broadcasted tab mode changes
      this._onModeEvt = (e) => this.setMode(e.detail?.mode);
      this._sectionRoot.addEventListener('glory:mode', this._onModeEvt);
       // Observe section attribute changes (data-glory-mode)
      this._modeAttrMO = new MutationObserver((muts) => {
        if (muts.some(m => m.attributeName === 'data-glory-mode')) {
          const mval = this._sectionRoot.getAttribute('data-glory-mode');
          this.setMode(mval);
        }
      });
      this._modeAttrMO.observe(this._sectionRoot, { attributes: true, attributeFilter: ['data-glory-mode'] });


      this.handle = this.getAttribute('handle');
      this.ray_handle = this.getAttribute('ray-handle');
      this.ray_lite_handle = this.getAttribute('ray-lite-handle');
      this.ray_discount = this.getAttribute('ray-discount');
      this.formId = this.getAttribute('form-id');
      this.code = this.dataset.code || null;
      this.addonsSource = this.getAttribute('addons-source') || null;


      this._wireCartButtons();
      this._urlSyncReady = false;


      // DOM refs
      // this.$mountFieldset = this.querySelector('fieldset.oip');
      // this.$mountRadios = [...this.$mountFieldset.querySelectorAll('.oip__radio, input[name="mounting_type"]')];

      this.$mountFieldset = this.querySelector('fieldset.oip');
      this.$mountRadios = this.$mountFieldset
        ? Array.from(this.$mountFieldset.querySelectorAll('input[name="mounting_type"]'))
        : [];


      const adj = this.querySelector('input[name="adjustable"][value="before"]');
      if (adj) adj.checked = true;
      this.state.adjustable = 'before';

      this.$storageWrap = this.querySelector('[data-selector-type="storage-count"]');
      this.$storageRadios = this.$storageWrap ? [...this.$storageWrap.querySelectorAll('.variant-swatch__radio')] : [];
      this.$batteryWattSpan = this.querySelector('#battery-watt span');
      this.baseBatteryWatt = (() => {
        const txt = this.$batteryWattSpan?.textContent || '';
        const n = parseInt(txt.replace(/[^\d]/g, ''), 10);
        return Number.isFinite(n) ? n : 2035; // default base 2035
      })();

      this.$panelWrap = this.querySelector('[data-selector-type="solar-panel"]');
      this.$panelWattSpan = this.querySelector('#panel-watt span');
      this.$w200 = this.$panelWrap?.querySelector('[data-set="w200"]') || null;
      this.$wlite200 = this.$panelWrap?.querySelector('[data-set="w200lite"]') || null;

      this.$w200Radios = this.$w200 ? [...this.$w200.querySelectorAll('.variant-swatch__radio')] : [];
      this.$wlite200Radios = this.$wlite200 ? [...this.$wlite200.querySelectorAll('.variant-swatch__radio')] : [];


      // Event bindings
      this._bindMount();
      this._bindStorage();
      this._bindPanels();
      this._bindProductCardCheckbox();
      this._bindBundlePanel();
      this._bindAdjustable();

      // Load product & initialize
      this._loadProductJSON().then(() => {
        this._setDefaults();
        this._applyMountRules();
        this._refreshAvailability();
        this._updateVariantSelection();
        this._emitState();
        this._urlSyncReady = true;
      }).catch(() => {
        this._setDefaults();
        this._applyMountRules();
        this._emitState();
        this._urlSyncReady = true;
      });
    }

    disconnectedCallback() {
      this._sectionRoot?.removeEventListener('glory:mode', this._onModeEvt);
      this._modeAttrMO?.disconnect();
    }

    setMode(mode) {
      const next = (String(mode).toLowerCase() === 'bundle') ? 'bundle' : 'custom';
      if (this.state?.activeTab === next) return;

      this.state.activeTab = next;

      // Ensure bundle panel is bound when entering Recommendations
      if (next === 'bundle' && !this.$bundlePanel) this._bindBundlePanel?.();

      // Recompute + notify
      this._applyActiveTabVariant?.();  // selects bundle synthetic or custom variant
    }

    _bindBundlePanel() {
      const panel = document.querySelector('#tab1 .bundle-wrapper');
      if (!panel) return;
      this.$bundlePanel = panel;

      const syncSelected = () => {
        // 1) toggle UI selection
        const checked = panel.querySelector('.bundle-radio:checked');
        panel.querySelectorAll('.bundle-card, .box.bundle-card, .box').forEach(c => c.classList.remove('is-selected'));
        checked?.closest('.bundle-card, .box')?.classList.add('is-selected');

        // 2) if we are in bundle mode, apply selection → update prices/SOD
        if (this.state.activeTab === 'bundle') {
          this._applyActiveTabVariant();
          // Optional: broadcast for any listeners (e.g., analytics/SOD)
          this.dispatchEvent(new CustomEvent('glory:bundle-change', {
            detail: { bundle: this._getSelectedBundle() }, bubbles: true
          }));
        }
      };

      // Track radio changes
      panel.addEventListener('change', (e) => {
        if (e.target.matches('.bundle-radio')) syncSelected();
      });

      // Make clicking anywhere on the card select the radio
      panel.addEventListener('click', (e) => {
        const card = e.target.closest('.bundle-card, .box');
        if (!card) return;
        const r = card.querySelector('.bundle-radio');
        if (r && !r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // If cards are injected dynamically, keep selection in sync
      this._bundleMO?.disconnect();
      this._bundleMO = new MutationObserver(() => syncSelected());
      this._bundleMO.observe(panel, { childList: true, subtree: true });

      // Initial sync
      // Ensure one is checked (fallback to first if none)
      if (!panel.querySelector('.bundle-radio:checked')) {
        const first = panel.querySelector('.bundle-radio');
        if (first) {
          first.checked = true;
          first.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        syncSelected();
      }
    }

    _getSelectedBundle() {
      const root = this.$bundlePanel || document.querySelector('#tab1 .bundle-wrapper');
      if (!root) return null;

      // your card markup uses `.box` as the card; we also support `.bundle-card`
      const card = root.querySelector('.bundle-radio:checked')?.closest('.bundle-card, .box');
      if (!card) return null;

      // data-* are attached to the card element (see previous step where we added them)
      let sod = [];
      try { sod = JSON.parse(card.getAttribute('data-sod') || '[]'); } catch {}

      return {
        variantId: card.getAttribute('data-variant-id'),
        price:     Number(card.getAttribute('data-price'))   || 0,
        compare:   Number(card.getAttribute('data-compare')) || Number(card.getAttribute('data-price')) || 0,
        title:     card.getAttribute('data-title') || 'Bundle',
        handle:    card.getAttribute('data-handle') || '',
        sodItems:  Array.isArray(sod) ? sod : []
      };
    }

    _applyActiveTabVariant() {
      if (this.state.activeTab === 'bundle') {
        const b = this._getSelectedBundle();
        this.state.bundle = {
          id: b?.variantId,
          price: b?.price,
          compare_at_price: b?.compare ?? b?.price,
          available: true,
          title: b?.title || 'Bundle'
        };

        this._emitState();                        // emits glory:change with bundle SOD + totals
      } else {
        this._emitState();
      }
    }

    /* ---------------------------
      Data loading & parsing
    ----------------------------*/
    async _loadProductJSON() {
      if (!this.handle) return; // API call glory prod
      const url = `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}products/${this.handle}.js`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Product JSON fetch failed');
      const data = await res.json();
      this.state.product = data;
      this.state.variants = data.variants || [];

      if (!this.ray_handle) return; // API call ray prod
      const ray_url = `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}products/${this.ray_handle}.js`;
      const ray_res = await fetch(ray_url, { credentials: 'same-origin' });
      if (!ray_res.ok) throw new Error('Product JSON fetch failed');
      const ray_data = await ray_res.json();
      this.state.rayProduct = ray_data;
      this.state.rayVariants = ray_data.variants || [];

      if (!this.ray_lite_handle) return; // API call ray prod
      const ray_lite_url = `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}products/${this.ray_lite_handle}.js`;
      const ray_lite_res = await fetch(ray_lite_url, { credentials: 'same-origin' });
      if (!ray_res.ok) throw new Error('Product JSON fetch failed');
      const ray_lite_data = await ray_lite_res.json();
      this.state.rayLiteProduct = ray_lite_data;
      this.state.rayLiteVariants = ray_lite_data.variants || [];
    }

    _bindProductCardCheckbox() {
      // Find the element: prefer explicit selector, else nearest in the same section, else first on page
      const src = this.addonsSource
        ? document.querySelector(this.addonsSource)
        : this.closest('[id^="shopify-section"]')?.querySelector('product-card-checkbox')
          || document.querySelector('product-card-checkbox');

      if (!src) return;
      this.$productCardCheckbox = src;

      this._onPCCChange = (e) => {
        const items = e.detail?.items || [];
        this.state.addons = items.map(a => ({
          key: String(a.variantId),
          variantId: a.variantId,
          title: a.title,
          img_src: a.img_src,
          qty: Math.max(1, Number(a.qty) || 1),
          each: this._num(a.price),
          compare: this._num(a.compare || a.price),
          checked: true 
        }));
        // refresh SOD + totals + event payload
        this._emitState();
      };

      this.$productCardCheckbox.addEventListener('productcardcheckbox:change', this._onPCCChange);

      // Initial hydrate
      if (typeof this.$productCardCheckbox.getSnapshot === 'function') {
        const snap = this.$productCardCheckbox.getSnapshot();
        this._onPCCChange({ detail: snap });
      }
    }

    /* Extracts helpful info: which mount name, watt, count are present in a variant */
    _parseVariant(variant, isLite) {
      const optsArr = variant.options || [];
      const optsTxt = optsArr.join(' ').toLowerCase();
      const titleRaw = (variant.title || '');
      const title = titleRaw.toLowerCase();

      const liteDetected = isLite || /lite/i.test(titleRaw);

      let count = this._extractCountFromText(title) ?? this._extractCountFromText(optsTxt);
      let totalW = this._extractTotalW(title) ?? this._extractTotalW(optsTxt);

      const total200Wattage = 200 * count;
      return {
        id: variant.id,
        available: !!variant.available,
        watt: liteDetected ? "200W" : total200Wattage == totalW ? "200W": "285W",        // '200W' or '285W'
        count,        // number of panels inferred
        isLite: liteDetected
      };
    }

    _parseRayLiteVariant(variant) {
      const optsArr = variant.options || [];
      const optsTxt = optsArr.join(' ').toLowerCase();
      const titleRaw = (variant.title || '');
      const title = titleRaw.toLowerCase();

      // let count = this._extractCountFromText(title) ?? this._extractCountFromText(optsTxt);
      const countMatch = optsTxt.match(/(\d+)\s*(panel|panels|modul|module)/i);
      const count = countMatch ? parseInt(countMatch[1], 10) : 0;

      return {
        id: variant.id,
        available: !!variant.available,
        watt: "200W",        // '200W' or '285W'
        count,        // number of panels inferred
        mount: "", // to change 
        adjustable:"before" // to change
      };
    }

    _parseRayVariant(variant) {
      const optsArr = variant.options || [];
      const optsTxt = optsArr.join(' ').toLowerCase();

      let mount = variant.options[0].toLowerCase();
      const countMatch = optsTxt.match(/(\d+)\s*(panel|panels|modul|module)/i);
      const count = countMatch ? parseInt(countMatch[1], 10) : 0;

      const totalMatch = optsTxt.match(/\((\d+)\s*W/i);
      const totalWatt = totalMatch ? parseInt(totalMatch[1], 10) : 0;

      const adjustableOpt = variant.options[2].toLowerCase();
      const position = adjustableOpt.includes('vor der') ? 'before' : 'after';

      let wattType = 0;
      if (count > 0 && totalWatt > 0) {
        wattType = Math.round(totalWatt / count);
      }

      return { 
        id: variant.id,
        available: !!variant.available,
        watt: wattType + "W",
        count,
        mount,
        adjustable: position
      };
    }

    _extractCountFromText(t) {
      const m = t.match(/(\d+)\s*x/);
      return m ? parseInt(m[1], 10) : null;
    }

    _extractTotalW(title) {
      const t = String(title);

      // Matches: (2400W), (2,400W), (2.4kW), ( 800 W ), （1140W）
      const re = /[\(\uFF08]\s*([\d.,]+)\s*([kK])?\s*[wW](?!h)\s*[\)\uFF09]/;
      const m = t.match(re);
      if (!m) return null;

      let n = parseFloat(m[1].replace(/,/g, ''));
      if (!Number.isFinite(n)) return null;
      if (m[2]) n *= 1000;              // kW → W
      return Math.round(n);
    }

    /* ---------------------------
      Defaults & bindings
    ----------------------------*/
    // _setDefaults() {
    //   // --- Mount default: first enabled mount radio (prefer not "without" unless that's the only one)
    //   const firstMountRadio =
    //     this.$mountRadios.find(r => !r.disabled && r.id !== 'without') ||
    //     this.$mountRadios.find(r => !r.disabled) ||
    //     this.$mountRadios[0];

    //   if (firstMountRadio) {
    //     firstMountRadio.checked = true;

    //     if (firstMountRadio.id === 'without') {
    //       this.state.mountIndex = -1;
    //       this.state.mountType = null;
    //       this.state.prodIndex = -1;
    //       this.state.bracketVariantId = null;
    //       this.state.bracketPrice = null;
    //       this.state.bracketCompare = null;
    //     } else {
    //       this.state.mountIndex = this._mountIndexFromId(firstMountRadio.id);
    //       this.state.mountType  = firstMountRadio.dataset.rayVar || firstMountRadio.getAttribute('data-ray-var') || null;

    //       const card = this._getCheckedMountCard();
    //       const { prodIndex, bracketVariantId, bracketPrice, bracketCompare } = this._readMountMeta(card);
    //       this.state.prodIndex = prodIndex;
    //       this.state.bracketVariantId = bracketVariantId;
    //       this.state.bracketPrice = bracketPrice;
    //       this.state.bracketCompare = bracketCompare;
    //     }
    //   }

    //   // Panels default (unchanged)
    //   const r200x4 = this.$panelWrap?.querySelector('input[name="option_panel"][data-bind-value="200W"][value="4"]');
    //   const any200 = this.$panelWrap?.querySelector('input[name="option_panel"][data-bind-value="200W"]');
    //   if (r200x4) {
    //     r200x4.checked = true;
    //     this.state.panelWatt = '200W';
    //     this.state.panelCount = 4;
    //   } else if (any200) {
    //     any200.checked = true;
    //     this.state.panelWatt = '200W';
    //     this.state.panelCount = Number(any200.value) || 0;
    //   }
    //   this._updatePanelWatt();

    //   // Storage default (unchanged)
    //   if (this.$storageRadios?.length) {
    //     const r1 = this.$storageRadios.find(r => String(r.value) === '1') || this.$storageRadios[0];
    //     if (r1) {
    //       r1.checked = true;
    //       this.state.storageCount = Number(r1.value) || 0;
    //       this.state.storageVariantId = r1.dataset.variantId || null;
    //       this.state.storagePrice = r1.dataset.variantPrice || null;
    //       this.state.storageCompare = r1.dataset.variantCompare || null;
    //     }
    //   }
    //   this._updateBatteryWatt();
    // }

    _setDefaults() {
      const p = new URLSearchParams(window.location.search);
      const urlMount   = p.get('mount');
      const urlAdjust  = p.get('adjust');
      const urlPanels  = p.get('panels');
      const urlCount   = p.get('count');
      const urlStorage = p.get('storage');

      // --- Mount default ---
      const mountAliases = {
        // EN-friendly params
        'concrete':  ['beton'],
        'railing':   ['geländer', 'gelander'],
        'shield':    ['schild'],
        'glass':     ['glas'],
        // DE params (exact ray_var values)
        'beton':     ['beton'],
        'geländer':  ['geländer'],
        'gelander':  ['geländer'],
        'schild':    ['schild'],
        'glas':      ['glas'],
      };

      let mountRadioToCheck;

      if (urlMount) {
        if (urlMount === 'without') {
          mountRadioToCheck = this.$mountRadios.find(r => r.id === 'without');
        } else {
          const aliases = mountAliases[urlMount.toLowerCase()] || [urlMount.toLowerCase()];
          mountRadioToCheck = this.$mountRadios.find(r =>
            aliases.includes((r.getAttribute('data-ray-var') || '').toLowerCase())
          );
        }
      }

      if (!mountRadioToCheck) {
        mountRadioToCheck =
          this.$mountRadios.find(r => !r.disabled && r.id !== 'without') ||
          this.$mountRadios.find(r => !r.disabled) ||
          this.$mountRadios[0];
      }

      if (mountRadioToCheck) {
        mountRadioToCheck.checked = true;
        mountRadioToCheck.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // --- Adjustable bracket ---
      const adjValue = urlAdjust || 'before';
      const adjRadio = this.querySelector(`input[name="adjust_bracket"][value="${adjValue}"]`);
      if (adjRadio) {
        adjRadio.checked = true;
        adjRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // --- Panels default ---
      let panelRadio = null;

      if (urlPanels && urlCount !== null) {
        const bindVal = urlPanels
          .replace(/\s/g, '_')
          .replace(/lite_200w/i, '200W_lite')
          .replace(/200w_lite/i, '200W_lite')
          .replace(/200wlite/i,  '200W_lite')
          .replace(/200w$/i,     '200W')
          

        panelRadio = this.$panelWrap?.querySelector(
          `input[name="option_panel"][data-bind-value="${bindVal}"][value="${urlCount}"]`
        );
      }

      if (!panelRadio || panelRadio.disabled) {
        panelRadio =
          this.$panelWrap?.querySelector('input[name="option_panel"][data-bind-value="200W"][value="4"]') ||
          this.$panelWrap?.querySelector('input[name="option_panel"][data-bind-value="200W"]');
      }

      if (panelRadio) {
        panelRadio.checked = true;
        panelRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // --- Storage default ---
      let storageRadio = null;

      if (urlStorage !== null) {
        storageRadio = this.$storageRadios?.find(r => String(r.value) === String(urlStorage));
      }

      if (!storageRadio) {
        storageRadio = this.$storageRadios?.find(r => String(r.value) === '1') || this.$storageRadios?.[0];
      }

      if (storageRadio) {
        storageRadio.checked = true;
        storageRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }    

    _bindMount() {
      if (!this.$mountFieldset) return;

      this.$mountFieldset.addEventListener('change', (e) => {
        const inp = e.target;
        if (!inp || inp.name !== 'mounting_type') return;

        // "Without Bracket"
        if (inp.id === 'without') {
          this.state.mountIndex = -1;
          this.state.mountType = null;
          this.state.prodIndex = -1;
          this.state.bracketVariantId = null;
          this.state.bracketPrice = null;
          this.state.bracketCompare = null;

          // force adjustable to "before" and hide
          this.state.adjustable = 'before';
          const beforeRadio = this.querySelector('input[name="adjust_bracket"][value="before"]');
          if (beforeRadio) beforeRadio.checked = true;

        } else {
          // normal mount
          this.state.mountIndex = this._mountIndexFromId(inp.id);
          this.state.mountType  = inp.dataset.rayVar || inp.getAttribute('data-ray-var') || null;

          const mt = (this.state.mountType || '').toLowerCase();
          const enableAfter = (mt === 'glass' || mt === 'shield' || mt === 'railing' || mt === 'geländer' || mt === 'schild' || mt === 'glas');

          if (!enableAfter) {
            this.state.adjustable = 'before';
            const beforeRadio = this.querySelector('input[name="adjust_bracket"][value="before"]');
            if (beforeRadio) beforeRadio.checked = true;
          }

          const card = this._getCheckedMountCard();
          const { prodIndex } = this._readMountMeta(card);
          this.state.prodIndex = prodIndex;
          this._resolveBracketVariant();
        }

        this._toggleAdjustableVisibility();
        this._applyMountRules();
        this._refreshAvailability();
        this._updateVariantSelection();
        this._emitState();
      });
    }

    _bindAdjustable() {
      const wrap = this.querySelector('.adjustable-fieldset');
      if (!wrap) return;

      wrap.addEventListener('change', (e) => {
        const inp = e.target;
        if (!inp || inp.name !== 'adjust_bracket') return;
        this.state.adjustable = inp.value; // "before" | "after"
        this._updateVariantSelection();
        this._emitState();
      });
    }

    _bindStorage() {
      if (!this.$storageWrap) return;
      this.$storageWrap.addEventListener('change', (e) => {
        const inp = e.target;
        if (!inp || !inp.classList.contains('variant-swatch__radio')) return;

        // Quantity comes from value="0..5"
        const qty = Number(inp.value);
        if (Number.isFinite(qty)) {
          this.state.storageCount = qty;
        }

        // Memorize battery variant id from the checked input
        this.state.storageVariantId = inp.dataset.variantId || null;
        this.state.storageVariantPrice   = this._num(inp.dataset.variantPrice);
        this.state.storageVariantCompare = this._num(inp.dataset.variantCompare);

        // Update UI total wattage
        this._updateBatteryWatt();

        // Notify theme
        this._emitState();
      });
    }

    _bindPanels() {
      if (!this.$panelWrap) return;
      this.$panelWrap.addEventListener('change', (e) => {
        const inp = e.target;
        if (!inp || inp.name !== 'option_panel' || !inp.classList.contains('variant-swatch__radio')) return;
        
        // watt bucket from data-bind-value; quantity from value
        const bind = (inp.dataset.bindValue || inp.getAttribute('data-bind-value') || '').toUpperCase();
        const isLite = /lite/.test(bind.toLowerCase())
        const wattStr = isLite ? 'Lite 200W' : '200W';
        const count = Number(inp.value);
//        console.log("=====binding panels=====", wattStr)
//        console.log("=====count=====", count)

        this.state.panelWatt = wattStr;
        this.state.panelCount = Number.isFinite(count) ? count : 0;

        function disableAdjustableBracketAfter() {
          const inputs = document.querySelectorAll('.after-option');

          inputs.forEach(input => {
            input.style.pointerEvents = 'none';
            input.style.opacity = '0.4';
          });
        }

        function enableAdjustableBracketAfter() {
          const inputs = document.querySelectorAll('.after-option');

          inputs.forEach(input => {
            input.style.pointerEvents = '';
            input.style.opacity = '';
          });
        }

        if(!!isLite){
          disableAdjustableBracketAfter()
        }else{
          enableAdjustableBracketAfter()
        }            

        // Push to form + UI + listeners
        this._resolveBracketVariant();
        this._updateVariantSelection();
        this._updatePanelWatt();
        this._emitState();
      });
    }

    // --- helper: get the checked mount card (label.oip__card)
    _num(v) { const n = Number(v); return Number.isFinite(n) ? n : 0; }
    _money(cents) {
      if (window.Shopify?.formatMoney) {
        const fmt = window.theme?.moneyFormat || "${{amount}}";
        return Shopify.formatMoney(Math.round(cents), fmt);
      }
      // Fallback
      return (Math.round(cents)/100).toLocaleString(undefined, { style:'currency', currency:'USD' });
    }
    _sel(el, s) { return el?.querySelector(s) || null; }
    _setText(el, txt) { if (el) el.textContent = String(txt); }
    _show(el, on=true) { if (el) el.style.display = on ? '' : 'none'; }

    // _getCheckedMountCard() {
    //   const checked = this.$mountRadios.find(r => r.checked && r.id !== 'without');
    //   return checked ? checked.closest('.oip__item')?.querySelector('.variant-one__item') : null;
    // }

    _getCheckedMountInput() {
      return this.$mountRadios?.find(r => r.checked) || null;
    }

    _getCheckedMountCard() {
      const inp = this._getCheckedMountInput();
      if (!inp) return null;
      // label.oip__card is the "card" and holds the data-* meta
      // (both normal mounts and the "without" option have labels)
      return this.$mountFieldset?.querySelector(`label.oip__card[for="${CSS.escape(inp.id)}"]`) || null;
    }


    _toggleAdjustableVisibility() {
      const fieldset = this.querySelector('.adjustable-fieldset');
      const grid = this.querySelector('.oip__grid');
      const mt = (this.state.mountType || '').toLowerCase();

      if (!fieldset || !grid) return;

//      const show = (mt === 'glass' || mt === 'shield' || mt === 'railing' || mt === 'geländer' || mt === 'schild' || mt === 'glas');
      const show = false;

      /* -------------------------
        HIDE
      -------------------------- */
      if (!show) {
        fieldset.style.display = 'none';

        // unwrap if previously wrapped
        const row = grid.querySelector('.mount-extra-row');
        if (row && row.contains(fieldset)) {
          row.insertAdjacentElement('afterend', fieldset);
          row.remove();
        }
        return;
      }

      /* -------------------------
        SHOW
      -------------------------- */
      fieldset.style.display = 'flex';

      // ensure a full-width row container exists
      let row = grid.querySelector('.mount-extra-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'mount-extra-row';
      }

      // force full row width
      row.style.gridColumn = '1 / -1';

      // move fieldset into the row
      if (fieldset.parentElement !== row) {
        row.appendChild(fieldset);
      }

      const items = Array.from(grid.querySelectorAll('.oip__item'));

      // find selected mount index
      const selectedIdx = Math.max(
        0,
        items.findIndex(item => {
          const r = item.querySelector('input[name="mounting_type"]');
          return r && r.checked;
        })
      );

      // 🔑 TWO columns per row
      const COLS = 3;

      // last index of the selected row
      const rowEndIdx =
        Math.min(
          items.length - 1,
          Math.ceil((selectedIdx + 1) / COLS) * COLS - 1
        );

      const anchor = items[rowEndIdx];
      if (anchor) {
        anchor.insertAdjacentElement('afterend', row);
      } else {
        grid.appendChild(row);
      }
    }


    _updateBatteryWatt() {
      const qty = Number(this.state.storageCount) || 0;
      const total = this.baseBatteryWatt * (1 + qty);
      if (this.$batteryWattSpan) {
        this.$batteryWattSpan.textContent = `${total}Wh`;
      }
    }

    _getPerPanelWatt(wattStr) {
      const m = String(wattStr || '').match(/\d+/);
      return m ? Number(m[0]) : 0; // '200W' -> 200
    }
    _updatePanelWatt() {
      if (!this.$panelWattSpan) return;
      const per = this._getPerPanelWatt(this.state.panelWatt); // '200W'|'285W'
      const total = per * (Number(this.state.panelCount) || 0);
      this.$panelWattSpan.textContent = `${total}W`;
    }

    _readMountMeta(card) {
      if (!card) {
        return { prodIndex: null, bracketVariantId: null, mountName: '', bracketPrice: null, bracketCompare: null, bracketVariantIdLite: null, bracketPriceLite: null, bracketCompareLite: null };
      }

      const rawProd = card.dataset.prodIndex || card.getAttribute('data-prod-index');
      const prodIndex = (rawProd === 'null' || rawProd === '' || rawProd == null) ? null : (Number(rawProd) || null);

      const bracketVariantId = card.dataset.variantId || card.getAttribute('data-variant-id') || null;
      const bracketPrice     = card.dataset.variantPrice || card.getAttribute('data-variant-price') || null;
      const bracketCompare   = card.dataset.variantCompare || card.getAttribute('data-variant-compare') || null;

      const bracketVariantIdLite = card.dataset.variantIdLite || card.getAttribute('data-variant-id-lite') || null;
      const bracketPriceLite     = card.dataset.variantPriceLite || card.getAttribute('data-variant-price-lite') || null;
      const bracketCompareLite   = card.dataset.variantCompareLite || card.getAttribute('data-variant-compare-lite') || null;

      // normal mounts have .oip__title; without bracket has .oip__text
      const mountName =
        card.querySelector('.oip__title')?.textContent?.trim() ||
        card.querySelector('.oip__text')?.textContent?.trim() ||
        '';

      return { prodIndex, bracketVariantId, mountName, bracketPrice, bracketCompare, bracketVariantIdLite, bracketPriceLite, bracketCompareLite };
    }


    _mountIndexFromId(id) {
      // your radio id format: {{ product.id }}-mount-{{ forloop.index }}
      const m = id.match(/mount-(\d+)/);
      return m ? (parseInt(m[1], 10) - 1) : 0;
    }

    /* ---------------------------
      Mount rules & availability
    ----------------------------*/
    _resolveBracketVariant() {
      if (!this.state.mountType) {
        this.state.bracketVariantId = null;
        this.state.bracketPrice = null;
        this.state.bracketCompare = null;
        return;
      }
      const isLite = /lite/.test(this.state.panelWatt.toLowerCase());
      const card = this._getCheckedMountCard();
      const meta = this._readMountMeta(card);

      if (isLite && meta.bracketVariantIdLite) {
        this.state.bracketVariantId = meta.bracketVariantIdLite;
        this.state.bracketPrice     = meta.bracketPriceLite;
        this.state.bracketCompare   = meta.bracketCompareLite;
      } else if (!isLite && meta.bracketVariantId) {
        this.state.bracketVariantId = meta.bracketVariantId;
        this.state.bracketPrice     = meta.bracketPrice;
        this.state.bracketCompare   = meta.bracketCompare;
      } else {
        this.state.bracketVariantId = meta.bracketVariantId || null;
        this.state.bracketPrice     = meta.bracketPrice || null;
        this.state.bracketCompare   = meta.bracketCompare || null;
      }
    }

    _applyMountRules() {
      const pidx = this.state.prodIndex;
      let enable200 = false;
      let enablelite200 = false;

      if (pidx === 1) {
        enable200 = true;
      } else if(pidx === 2){
        enable200 = true;
        enablelite200 = true;
      } else if (pidx === null || pidx === -1) {
        enablelite200 = true;
        enable200 = true;
      }

      this._setGroupEnabled(this.$w200, this.$w200Radios, enable200);
      this._setGroupEnabled(this.$wlite200, this.$wlite200Radios, enablelite200);

      // If current selection is invalid (disabled group), auto-fallback
      if (!enablelite200 && this.state.panelWatt === 'Lite 200W'){
        if (enable200) {
          this._setDefault200();
        }
      }
    }
    _setDefault200() {
        const first = this.$w200Radios.find(r => !r.disabled) || this.$w200Radios[0];
        if (first) {
          first.checked = true;
          this.state.panelWatt = '200W';
          this.state.panelCount = Number(first.value) || 0;
          this._updatePanelWatt();
        }
    }


    _setGroupEnabled(groupEl, radios, enabled) {
      if (!groupEl) return;
      groupEl.style.pointerEvents = enabled ? '' : 'none';
      groupEl.style.opacity = enabled ? '' : '0.4';
      radios.forEach(r => {
        r.disabled = !enabled;
        const wrap = r.closest('.card__quantity-button-wrapper');
        if (wrap) wrap.classList.toggle('is-disabled', !enabled);
      });
    }

    _wireCartButtons() {
      const form = this.formId ? document.getElementById(this.formId) : null;
      if (!form) return;

      const requiresTaxPopup = !!this._sectionRoot.querySelector('.tax-info');
           
      this.state.taxConfirmed = false;
      this.state.pendingBuyNow = false;

            // show popup
      const showPopup = () => {
        document.documentElement.dispatchEvent(new CustomEvent('ray:tax-popup', {
          bubbles: true
        }));
      };

            // confirmation event from popup
      this._onTaxConfirm = () => {
        this.state.taxConfirmed = true;
        this._addBundleToCart({ buyNow: this.state.pendingBuyNow });

        // reset state after add to cart
        this.state.taxConfirmed = false;
        this.state.pendingBuyNow = false;

        // reset popup UI
        const backdrop = document.querySelector('.tax-info-popup-backdrop');
        const checkbox = backdrop?.querySelector('#vat-inclusion');
        const continueBtn = backdrop?.querySelector('.button.button--primary');

        if (checkbox) checkbox.checked = false;
        if (continueBtn) continueBtn.disabled = true;
      };

      document.documentElement.addEventListener('ray:tax-confirm', this._onTaxConfirm);

      // ---- helper to intercept clicks
      const intercept = (e, buyNow) => {
        e.preventDefault();

        if (requiresTaxPopup && !this.state.taxConfirmed) {
          this.state.pendingBuyNow = buyNow;
          showPopup();
          return;
        }

        // no popup, or confirmed
        this._addBundleToCart({ buyNow });

        // reset after success (normal path)
        this.state.taxConfirmed = false;
      };


      // form.addEventListener('submit', (e) => {
      //   e.preventDefault();
      //   this._addBundleToCart({ buyNow: false });
      // });
      const atcBtn = form.querySelector('[data-bundle-atc]');
      const buyBtn = form.querySelector('[data-bundle-buynow]');

      if (atcBtn) atcBtn.addEventListener('click', (e) => intercept(e, false));
      if (buyBtn) buyBtn.addEventListener('click', (e) => intercept(e, true));

      // (optional) block enter key submit
      form.addEventListener('submit', (e) => intercept(e, false));

      // const atcBtn = form.querySelector('[data-bundle-atc]');
      // if (atcBtn) atcBtn.addEventListener('click', (e) => {
      //   e.preventDefault();
      //   this._addBundleToCart({ buyNow: false });
      // });

      // const buyNowBtn = form.querySelector('[data-bundle-buynow]');
      // if (buyNowBtn) buyNowBtn.addEventListener('click', (e) => {
      //   e.preventDefault();
      //   this._addBundleToCart({ buyNow: true });
      // });
    }

    _composeBundleItems() {
      let items = [];

      if (this.state.activeTab === 'bundle') {
        const b = this._getSelectedBundle();
        if (b?.variantId) {
          items.push({ id: Number(b.variantId), quantity: 1 });
        }
        // add-ons from ProductCardCheckbox (if any)
        (this.state.addons || []).forEach(a => {
          if (!a.variantId || a.qty <= 0) return;
          items.push({ id: Number(a.variantId), quantity: Number(a.qty) });
        });
        return items;
      } else {
        // Main variant (selected variant must exist)
        const main = this.state.selectedVariant;
        if (!main) return [];

        const panelQty = Number(this.state.panelCount) || 0;
        const storageQty = Number(this.state.storageCount) || 0;
        const hasBracket = this.state.mountType ? true : false;
        const bracketQty = hasBracket ? panelQty : 0;

        items = [{
          id: Number(main.id),
          quantity: 1,
        }];

        // Bracket as independent product
        if (hasBracket && bracketQty > 0 && this.state.bracketVariantId) {
          items.push({
            id: Number(this.state.bracketVariantId),
            quantity: bracketQty
          });
        }

        // Expansion batteries
        if (this.state.storageVariantId && storageQty > 0) {
          items.push({
            id: Number(this.state.storageVariantId),
            quantity: storageQty
          });
        }

        this.state.addons
          .filter(a => a.checked && a.variantId && a.qty > 0)
          .forEach(a => {
            items.push({
              id: Number(a.variantId),
              quantity: a.qty
            });
          });

        return items;
      }
    }

    async _addBundleToCart({ buyNow = false } = {}) {
      const items = this._composeBundleItems();
      if (!items.length) {
        console.warn('[glory-variants] No items to add (no selectedVariant?)');
        return;
      }
      this._setBusy(true);

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });

        const addJson = await addRes.json();
        if (!addRes.ok) {
          document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
            bubbles: true,
            cancelable: true,
            detail: { status: 'error', error: addJson?.description || 'An error occurred' }
          }));
          throw new Error(addJson?.description || `Cart add failed (${addRes.status})`);
        }

        const popup = document.querySelector(".product-popup");
        const popupClose = document.querySelector(".popup-close");

        if (popup && popup.classList.contains("active")) {
          popupClose.click();
        }

         // Fire "variant:added" with first item (same as your example)
        document.documentElement.dispatchEvent(new CustomEvent('variant:added', {
          bubbles: true,
          detail: {
            variant: addJson.hasOwnProperty('items') ? addJson.items[0] : addJson
          }
        }));
        const cartUrl = (window.themeVariables?.routes?.cartUrl || '/cart') + '.js';
        const cartRes = await fetch(cartUrl, { headers: { 'Accept': 'application/json' } });
        if (cartRes.ok) {
        const cartContent = await cartRes.json();

        // Fire cart:updated
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartContent }
        }));

        // Attach any sections returned by /cart/add.js (if theme uses them)
        if (addJson.sections) cartContent.sections = addJson.sections;

        // Fire cart:refresh (theme listens to this to render UI)
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart:
              window.themeVariables?.settings?.cartType === 'drawer' &&
              document.querySelector('.drawer') === null
          }
        }));
        }

        if (buyNow) {
          // After adding bundle, go straight to checkout
          window.location.href = '/checkout';
          return;
        }

        // Open mini-cart by clicking the header trigger (same as your example)
        const headerCart = document.querySelector('.header_show-cart');
        if (headerCart) headerCart.click();
       
      } catch (e) {
        console.error('[glory-variants] Add bundle failed:', e);
        // Optional: show toast/snackbar
        alert(e.message || 'Something went wrong adding to cart.');
      } finally {
        this._setBusy(false);
      }
    }

    async _openCartDrawer(addResponse = null) {
      // 1) Dawn-style <cart-drawer> component
      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl) {
        try {
          // If /cart/add.js returned sections, let Dawn render them
          if (addResponse?.sections && typeof drawerEl.renderContents === 'function') {
            drawerEl.renderContents(addResponse);
          } else if (typeof drawerEl.renderContents === 'function') {
            // Otherwise fetch the drawer sections and render
            const res = await fetch(`${Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
            const json = await res.json();
            drawerEl.renderContents({ sections: json, sections_url: window.location.pathname });
          }
        } catch (e) {
          // swallow and try to just open visually
        }
        // Open it (Dawn accepts either .open() or adding classes/attrs)
        if (typeof drawerEl.open === 'function') drawerEl.open();
        drawerEl.classList.add('is-open');
        drawerEl.setAttribute('open', '');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
        return;
      }

      // 2) “CartDrawer” container patterns
      const idDrawer = document.getElementById('CartDrawer');
      if (idDrawer) {
        try {
          if (addResponse?.sections?.['cart-drawer']) {
            const doc = new DOMParser().parseFromString(addResponse.sections['cart-drawer'], 'text/html');
            const src = doc.getElementById('CartDrawer');
            if (src) idDrawer.innerHTML = src.innerHTML;
          } else {
            const res = await fetch(`${Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
            const json = await res.json();
            if (json['cart-drawer']) {
              const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
              const src = doc.getElementById('CartDrawer');
              if (src) idDrawer.innerHTML = src.innerHTML;
            }
          }
        } catch (e) {}
        idDrawer.classList.add('is-open', 'active', 'open');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
        return;
      }

      // 3) Fire common events many themes listen for
      ['cart:open', 'cart:refresh', 'cart:updated', 'ajaxProduct:added', 'theme:cart:added'].forEach(name => {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });

      // 4) Try clicking a toggle button
      const toggle = document.querySelector(
        '[data-cart-toggle], [aria-controls="CartDrawer"], .header__icon--cart button, .header__icon--cart a'
      );
      if (toggle) { toggle.click(); return; }

      // 5) Last resort: go to the cart page
      window.location.href = '/cart';
    }

    _setBusy(on) {
      const form = this.formId ? document.getElementById(this.formId) : null;
      if (!form) return;
      form.classList.toggle('is-loading', !!on);
      const btns = form.querySelectorAll('[data-bundle-atc], [data-bundle-buynow], .product-form__submit');
      btns.forEach(b => b.disabled = !!on);
    }

    // Patch _refreshAvailability():
    _refreshAvailability() {
      console.log("====refreshing the state====", this.state)

      if (!this.state.product) {
        return;
      }

    }


    /* ---------------------------
      Variant resolution & form sync
    ----------------------------*/
    _currentMountName() {
      const card = this._getCheckedMountCard();
      const { mountName } = this._readMountMeta(card) || { mountName: '' };
      return mountName || '';
    }


    _findGloryVariant({ watt, count}) {
      if (!this.state?.product) return null;

      // Build cache once
      if (!this._parsedVariants) {
        this._parsedVariants = (this.state.variants || []).map(v => ({
          raw: v,
          meta: this._parseVariant(v) // must yield { watt: '200W'|'285W', count, available }
        }));
      }
      const wantCount = Number(count) || 0;
      const isLiteWatt = /lite/i.test(watt);
      const wantWatt = String(watt || '').toUpperCase().replace(/^LITE\s+/, '');
      let candidates = this._parsedVariants.filter(v => Number(v.meta.count) === wantCount);      

      // If count > 0, also require watt match
      if (wantCount > 0 && wantWatt) {
        candidates = candidates.filter(v => String(v.meta.watt).toUpperCase() === wantWatt);
      }

      if (wantWatt === '200W') {
        candidates = candidates.filter(v => !!v.meta.isLite === isLiteWatt || wantCount === 0);
      }

      // Prefer available
      const available = candidates.find(v => v.raw.available || v.meta.available);
      return available || candidates[0] || null;
    }

    _findRayVariant({ watt, count, mountType, adjustable }) {
      const isLite = /lite/.test(watt.toLowerCase())

      // takes in form data, returns variant id
      if (!this.state?.rayProduct) return null;

      if(!this.state?.rayLiteProduct && !!isLite) return null

      // Build cache once
      if (!this._parsedRayVariants) {
        this._parsedRayVariants = (this.state.rayVariants || []).map(v => ({
          raw: v,
          meta: this._parseRayVariant(v) // must yield { watt: '200W'|'285W', count, available }
        }));
      }

      if (!this._parsedRayLiteVariants) {
        this._parsedRayLiteVariants = (this.state.rayLiteVariants || []).map(v => ({
          raw: v,
          meta: this._parseRayLiteVariant(v) // must yield { watt: '200W'|'285W', count, available }
        }));

      }
      
      const formatSplit = watt.split(" ")
      const sanitizedWatt = formatSplit[formatSplit.length-1]      

      let qty = 1;
      let wantCount = Number(count) || 0;
      let wantWatt  = String(sanitizedWatt || '').toUpperCase();

      if (watt === '200W' && wantCount > 6) {
        // divide by 2 (round up) and mark qty 2
        wantCount = Math.ceil(wantCount / 2);
        qty = 2;
      } else if (/lite/.test(watt.toLowerCase()) && wantCount > 6){
        // divide by 2 (round up) and mark qty 2
        wantCount = Math.ceil(wantCount / 2);
        qty = 2;
      }

      if (wantCount > 0){
        let variantArr 
        if(!!isLite){
          variantArr = this._parsedRayLiteVariants
        }else{
          variantArr = this._parsedRayVariants
        }

        const normalFilter = (v) =>
          (Number(v.meta.count) === wantCount) &&
          (v.meta.watt === wantWatt) &&
          (v.meta.mount === mountType) && 
          (v.meta.adjustable == adjustable)

        const liteFilter = (v) =>
          (Number(v.meta.count) === wantCount) &&
          (v.meta.watt === wantWatt) && 
          (v.meta.adjustable == adjustable)

        let candidates = variantArr.filter((v) => isLite ? liteFilter(v) : normalFilter(v));

        const available = candidates.find(v => v.raw.available);
        return available ? { ...available, qty }:null;  

      } else {
        return null;
      }
    }

    _updateVariantSelection() { // Determine glory variant
      const { panelWatt, panelCount } = this.state;
      const match = this._findGloryVariant({ 
        watt: panelWatt, 
        count: panelCount 
      });

      if (match) {
        this.state.selectedVariant = match.raw;
        this.state.selectedRayVariant = null;
        this.state.selectedRayQty = 0;
        
        this._toggleSoldOutMessage(false);
      } else {
        this._toggleSoldOutMessage(true);
      }
    }

    _toggleSoldOutMessage(show) {
      // hook for your UI if you want to reveal an error text
      this.classList.toggle('variant-unavailable', !!show);
    }

    /* ---------------------------
      Theme integration events
    ----------------------------*/
    _emitState() {
      const card = this._getCheckedMountCard?.();
      const { mountName } = this._readMountMeta?.(card) || { mountName: '' };

      // --- quantities
      const panelQty   = Number(this.state.panelCount) || 0;
      const storageQty = Number(this.state.storageCount) || 0;

      const isBundle = this.state.activeTab === 'bundle';
      const bundle = isBundle ? (this._getSelectedBundle?.() || this.state.bundle || null) : null;

      // --- base/main variant prices
      const basePrice   = isBundle
        ? Number(bundle?.price)
        : Number(this.state.selectedVariant?.price);

      const baseCompare = isBundle
        ? (Number(bundle?.compare) || Number(bundle?.price))
        : (Number(this.state.selectedVariant?.compare_at_price) || Number(this.state.selectedVariant?.price));

      // --- extras: each price + compare (robust to naming)
      const expansionEach        = isBundle ? 0 : this._num(this.state.storageVariantPrice ?? this.state.storagePrice);
      const expansionCompareEach = isBundle ? 0 : this._num(this.state.storageVariantCompare ?? this.state.storageCompare);
      const bracketEach          = isBundle ? 0 : this._num(this.state.bracketPrice);
      const bracketCompareEach   = isBundle ? 0 : this._num(this.state.bracketCompare);

      // helper to compute line totals
      const line = (qty, each, eachCmp) => {
        const q = Number(qty) || 0;
        const e = this._num(each);
        const c = this._num(eachCmp) || e;
        const price   = q * e;
        const compare = q * c;
        const save    = Math.max(0, compare - price);
        return { qty: q, each: e, price, compare, save };
      };

      // ⬇️ add-ons aggregate + per-item detail
      const addonsRaw = (this.state.addons || []).filter(a => a.variantId && a.qty > 0);
      const addonsItems = addonsRaw.map(a => {
        const l = line(a.qty, a.each, a.compare);
        return { img_src: a.img_src, title: a.title, variantId: a.variantId, ...l };
      });
      const addonsTotals = addonsItems.reduce((acc, it) => {
        acc.price += it.price; acc.compare += it.compare; acc.save += it.save; return acc;
      }, { price:0, compare:0, save:0 });

      const lines = {
        base: {
          qty: 1,
          each: basePrice,
          price: basePrice,
          compare: baseCompare,
          save: Math.max(0, baseCompare - basePrice),
        },
        panels: isBundle
          ? { qty: 0, each: 0, price: 0, compare: 0, save: 0, wattBucket: null }
          : { qty: panelQty, each: 0, price: 0, compare: 0, save: 0, wattBucket: this.state.panelWatt },
        expansion: isBundle ? { qty: 0, each: 0, price: 0, compare: 0, save: 0 }
                            : line(storageQty, expansionEach, expansionCompareEach),
        bracket:   isBundle ? { qty: 0, each: 0, price: 0, compare: 0, save: 0 }
                            : (this.state.mountType ? line(panelQty, bracketEach, bracketCompareEach)
                                                          : { qty: 0, each: 0, price: 0, compare: 0, save: 0 }),
        addons: { items: addonsItems, price: addonsTotals.price, compare: addonsTotals.compare, save: addonsTotals.save }
      };

      // grand totals
      const grandPrice   = lines.base.price + lines.panels.price + lines.expansion.price + lines.bracket.price + lines.addons.price;
      const grandCompare = lines.base.compare + lines.panels.compare + lines.expansion.compare + lines.bracket.compare + lines.addons.compare;
      const grandSave    = Math.max(0, grandCompare - grandPrice);
      const detail = {
        mode: isBundle ? 'bundle' : 'custom',
        mountIndex: this.state.mountIndex,
        mountType: this.state.mountType,
        prodIndex: this.state.prodIndex,
        mountName,
        adjustable: this.state.adjustable,
        panel: { watt: this.state.panelWatt, count: this.state.panelCount },
        storage: {
          count: this.state.storageCount,
          variantId: this.state.storageVariantId,
          baseWatt: this.baseBatteryWatt,
          totalWatt: this.baseBatteryWatt * (1 + (Number(this.state.storageCount) || 0))
        },
        bracketVariantId: this.state.bracketVariantId,
        derived: {
          bracketQuantity: this.state.mountType?Math.max(0, Number(this.state.panelCount) || 0):null,
          selectedRayQty: 0
        },
        addons: addonsItems,
        bundle: isBundle ? { variantId: bundle?.variantId || null, sod: Array.isArray(bundle?.sodItems) ? bundle.sodItems : [] } : null,
      };

      const prices = {
        basePrice,
        baseCompare,
        expansionEach,
        expansionCompareEach,
        bracketEach,
        bracketCompareEach,
        grandPrice : this._num(grandPrice),
        grandCompare : this._num(grandCompare),
        grandSave : this._num(grandSave)
      };
      this.dispatchEvent(new CustomEvent('glory:change', { detail: {...detail, prices}, bubbles: true }));
      this._syncUrlParams();
    }

    _syncUrlParams() {
      if (!this._urlSyncReady) return;

      const url = new URL(window.location.href);

      // Mount
      const mountInput = this.$mountRadios?.find(r => r.checked);
      if (mountInput) {
        if (mountInput.id === 'without') {
          url.searchParams.set('mount', 'without');
        } else {
          const rayVar = mountInput.getAttribute('data-ray-var') || '';
          if (rayVar) url.searchParams.set('mount', rayVar);
          else url.searchParams.delete('mount');
        }
      } else {
        url.searchParams.delete('mount');
      }

      // Adjust
      if (this.state.adjustable && this.state.adjustable !== 'before') {
        url.searchParams.set('adjust', this.state.adjustable);
      } else {
        url.searchParams.delete('adjust');
      }

      // Panels
      if (this.state.panelWatt) {
        const pv = this.state.panelWatt.replace(/\s/g, '_');
        url.searchParams.set('panels', pv === 'Lite_200W' ? '200W_lite' : pv);
      } else {
        url.searchParams.delete('panels');
      }

      // Count
      if (this.state.panelCount !== null && this.state.panelCount !== undefined) {
        url.searchParams.set('count', String(this.state.panelCount));
      } else {
        url.searchParams.delete('count');
      }

      // Storage
      if (this.state.storageCount !== null && this.state.storageCount !== undefined) {
        url.searchParams.set('storage', String(this.state.storageCount));
      } else {
        url.searchParams.delete('storage');
      }

      window.history.replaceState({}, '', url.toString());
    }

  };
  window.customElements.define("glory-variants", GloryVariants);

  var GlorySOD = class extends CustomHTMLElement {
    connectedCallback() {
      // Source <glory-variants>
      const forSel = this.getAttribute('for');
      this.$source = forSel ? document.querySelector(forSel) : this._nearestVariants();
      if (!this.$source) {
        console.warn('[glory-sod] Could not locate <glory-variants>. Provide `for="#id"`.'); 
        return;
      }
      // Use the element’s own children as the box
      this.$box = this.firstElementChild || this;

      this.$rowBase    = this.$box.querySelector('[data-sod-row="base-battery"]') || null;
      this.$rowExpand  = this.$box.querySelector('[data-sod-row="expansion"]') || null;
      this.$rowBracket = this.$box.querySelector('[data-sod-row="bracket"]') || null;
      this.$dynamic    = this.querySelector('[data-sod-dynamic]');    
      this.$grand = this.querySelector('[data-sod-grand]');


      this._onChange = (e) => {
        if (e.target !== this.$source && e.currentTarget !== this.$source) return;
        // Prefer event payload; fall back to snapshot if needed
        const detail = e.detail || (typeof this.$source.getSnapshot === 'function' ? this.$source.getSnapshot() : null);
        this.render(detail);
      };
      this.$source.addEventListener('glory:change', this._onChange);

      // Initial paint
      if (typeof this.$source.getSnapshot === 'function') {
        try { this.render(this.$source.getSnapshot()); } catch(e) {}
      }
    }

    disconnectedCallback() {
      if (this.$source && this._onChange) {
        this.$source.removeEventListener('glory:change', this._onChange);
      }
    }

    /* ---------------- Rendering ---------------- */
    render(detail) {

      if (!detail) return;
      // Pull data from either the rich snapshot or minimal event
      const money = (c) => detail.prices?.money ? detail.prices.money(c) : this._money(c);

      const isBundle = detail.mode === 'bundle';
      if (isBundle) {
        const sod = (detail.bundle && Array.isArray(detail.bundle.sod))
        ? detail.bundle.sod
        : this._readBundleSodFromDom();

        const bundleTitle = detail.bundle?.title || this._readBundleTitleFromDom() || 'Glory Power Storage Bundle';
        const bundlePriceCents = Number(detail?.prices?.basePrice) || 0; // bundle price from GloryVariants

        // const isBaseTitle = (t) => String(t || '').replace(/\s+/g, ' ').trim().toLowerCase() === 'glory_0';

        // hide the fixed 3 rows; show dynamic list
        this._show(this.$rowBase, false);
        this._show(this.$rowExpand, false);
        this._show(this.$rowBracket, false);

        if (this.$dynamic){
          this.$dynamic.innerHTML = '';
        }
        
        if (sod && sod.length) {
          let row = this._makeRow();
          const qtyText = `1x`;
          const rowTitle = bundleTitle;
          const rowPrice = this._money(bundlePriceCents);
          this._setRow(row, { qty: qtyText, title: rowTitle, price: rowPrice });
          // this.$dynamic.appendChild(row);
          this._show(this.$dynamic, true);
          this._renderMinSOD();
        } else {
          this._show(this.$dynamic, false);
        }

      } else {
        this._show(this.$dynamic, false);
        // Panels
        const panelQty   = Number(detail.panel?.count ?? 0);
        const panelWattT = Number(detail.panel?.totalWatt ?? 0); // e.g., 800
        const panelTitle = panelWattT ? `${panelWattT} Watt Solarpanels` : (detail.panel?.watt ? `${detail.panel.watt} Solarpanels` : 'Solarpanels');

        // Storage
        const storageQty = Number(detail.storage?.qty ?? detail.storage?.count ?? 0);
        const storagePrice = Number(detail.prices?.expansionEach * storageQty);
        // Bracket
        const hasBracket = detail.derived?.bracketQuantity? true: false;
        const bracketQty = Number(detail.bracket?.qty ?? detail.derived?.bracketQuantity ?? 0);
        const bracketPrice = Number(detail.prices?.bracketEach * bracketQty);
        const bracketCompare = Number(detail.prices?.bracketCompareEach * bracketQty);

        // Prices
        const basePrice    = Number(detail.prices?.basePrice || 0);

        let baseLabel = '1x';
        let baseTitle = 'Glory Energiespeicher';
        if (panelQty > 0) {
          baseTitle += ` + ${panelQty}x ${panelTitle}`;
        }

        // Write rows
        this._writeRow(this.$rowBase, baseLabel, baseTitle, money(basePrice));
        this._show(this.$rowBase, true);

        const storageName = storageQty > 1 ? 'Erweiterungsakkus' : 'Erweiterungsakku';
        this._writeRow(this.$rowExpand,  `${storageQty}x`, storageName, money(storagePrice));
        this._show(this.$rowExpand, storageQty > 0);

        const bracketLabel = 'Halterungen';

        this._writeRow(this.$rowBracket, `${bracketQty}x`, `${bracketLabel}`, money(bracketPrice));
        this._show(this.$rowBracket, hasBracket && bracketQty > 0);

        this._renderMinSOD();

      }


      // Add-ons container (create if absent)
      let addonsBox = this.$box.querySelector('[data-sod-addons]');
      if (!addonsBox) {
        addonsBox = document.createElement('div');
        addonsBox.setAttribute('data-sod-addons','');
        addonsBox.className = 'sod-line-item-group';
        // insert after bracket row
        (this.$rowBracket?.parentNode || this.$box).insertBefore(addonsBox, this.$rowBracket?.nextSibling || null);
      } else {
        addonsBox.innerHTML = '';
      }

      const addonItems = detail.prices?.lines?.addons?.items || detail.addons || [];
      if (addonItems.length) {
        addonItems.forEach(it => {
          const row = document.createElement('div');
          row.className = 'sod-line-item';
          row.innerHTML = `
            <div class="h_16">${it.qty}x</div>
            <div class="h_16">${this._escape(it.title || 'Add-on')}</div>
            <div class="h_16 sod-price" style="font-weight:600;">${money(it.price)}</div>
          `;
          addonsBox.appendChild(row);
        });
      }


      const grandPrice = Number(detail.prices?.grandPrice || 0);

      // 获取所有有效的badge
      const badges = [...document.querySelectorAll('.free-badge')]
          .map(b => ({ el: b, threshold: Number(b.dataset.priceThreshold || 0), tier: b.dataset.tier }))
          .sort((a, b) => a.threshold - b.threshold);
      console.log("========badges in text======", badges)

      // 找到最后一个满足条件的并显示
      const visibleBadge = badges.filter(b => b.threshold <= grandPrice).pop();
      console.log("========visibleBadge======", visibleBadge)

      // 移除旧的赠品行（如果存在）
      const oldGiftRow = addonsBox.querySelector('.gift-row');
      if (oldGiftRow) oldGiftRow.remove();

      if (visibleBadge) {
          const tier = visibleBadge.tier;
          // 从 DOM data-gifts 读取礼品配置
          const freeGiftEl = document.getElementById('pdp-free-gift');
          let giftsData = {};
          if (freeGiftEl && freeGiftEl.dataset.gifts) {
            try { giftsData = JSON.parse(freeGiftEl.dataset.gifts); } catch(e) {}
          }
          const tierKey = tier === '0' ? 'tier0' : 'tier1';
          const gifts = giftsData[tierKey] || [];

          // 清空原有内容（如果需要）
          // addonsBox.innerHTML = '';

          gifts.forEach((gift) => {
            if (!gift.quantity) return;
            const row = this._createGiftRow(
              tier === '0' ? 0 : 1,
              `
                <div class="h_16">${gift.quantity}</div>
                <div class="h_16">${gift.name}</div>
                <div class="h_16 sod-price" style="font-weight:600;">${gift.price}</div>
              `
            );
            addonsBox.appendChild(row);
          });
      }

      // Totals
      const $grandPrice   = this.$grand?.querySelector('[data-sod-grand-price]');
      const $grandCompare = this.$grand?.querySelector('[data-sod-grand-compare]');
      const $grandSave    = this.$grand?.querySelector('[data-sod-grand-save]');

      if ($grandPrice)   $grandPrice.textContent = money(detail.prices?.grandPrice);


      if ($grandCompare) {
        if (Number(detail.prices?.grandCompare) > Number(detail.prices?.grandPrice)) {
          $grandCompare.textContent = money(detail.prices?.grandCompare);
          $grandCompare.style.display = '';
        } else {
          $grandCompare.textContent = '';
          $grandCompare.style.display = 'none';
        }
      }
      if ($grandSave) {
        if (detail.prices?.grandSave > 0) {
          $grandSave.textContent = `${money(detail.prices?.grandSave)} Rabatt`;
          $grandSave.style.display = '';
        } else {
          $grandSave.textContent = '';
          $grandSave.style.display = 'none';
        }
      }
    }

    _createGiftRow(tier, innerHTML) {
      const giftRow = document.createElement("div");
      giftRow.className = "sod-line-item gift-row";
      giftRow.dataset.giftTier = tier;
      giftRow.innerHTML = innerHTML
      return giftRow;
    }

    _renderMinSOD() {
      // Only look inside THIS <glory-sod>, never the whole document
      const root    = this; 
      const minWrap = root.querySelector('[data-sod-min]');
      if (!minWrap) return;

      const minDescEl = minWrap.querySelector('[data-sod-min-desc]');
      if (!minDescEl) return;

      const parts = [];

      // Check visibility directly on the element via inline style
      // (avoids ancestor traversal issues since all rows are inside <glory-sod>)
      const isRowVisible = (el) => {
        if (!el) return false;
        return el.style.display !== 'none';
      };

      // Collect from fixed rows using direct element references
      // (avoids [data-sod-row] query which could match duplicated elements)
      const sodRows = [
        this.$rowBase,
        this.$rowExpand,
        this.$rowBracket,
      ];

      sodRows.forEach(rowEl => {
        if (!isRowVisible(rowEl)) return;
        const qty   = rowEl.querySelector('[data-sod-qty]')?.textContent?.trim();
        const title = rowEl.querySelector('[data-sod-title]')?.textContent?.trim();
        if (qty && title) parts.push(`${qty} ${title}`);
      });

      // Collect from groups (dynamic bundle + addons) only if the GROUP is visible
      const collectGroup = (sel) => {
        const group = root.querySelector(sel);
        if (!group || group.style.display === 'none') return;
        group.querySelectorAll('.sod-line-item').forEach(row => {
          if (row.style.display === 'none') return;
          const qty   = row.querySelector('[data-sod-qty]')?.textContent?.trim();
          const title = row.querySelector('[data-sod-title]')?.textContent?.trim();
          if (qty && title) parts.push(`${qty} ${title}`);
        });
      };

      collectGroup('[data-sod-dynamic]');
      collectGroup('[data-sod-addons]');

      // Write or clear
      minDescEl.textContent = parts.length ? parts.join(' + ') : '';
    }


    _writeRow(row, qtyText, titleText, priceText) {
      if (!row) return;
      const cells = row.querySelectorAll('.h_16');
      if (cells[0]) cells[0].textContent = qtyText;
      if (cells[1]) cells[1].textContent = titleText;
      if (cells[2]) cells[2].textContent = priceText;
    }

    _makeRow() {
      const div = document.createElement('div');
      div.className = 'sod-line-item';
      div.innerHTML = `
        <div class="h_16 sod-qty"   data-sod-qty>1x</div>
        <div class="h_16 sod-title" data-sod-title></div>
        <div class="h_16 sod-price" data-sod-price style="font-weight:600;">-</div>
      `;
      return div;
    }
    _setRow(row, { qty, title, price }) {
      if (!row) return;
      if (qty   != null) (row.querySelector('[data-sod-qty]')   || row.children[0]).textContent = qty;
      if (title != null) (row.querySelector('[data-sod-title]') || row.children[1]).textContent = title;
      if (price != null) (row.querySelector('[data-sod-price]') || row.children[2]).textContent = price;
    }

    _show(el, on=true) { if (el) el.style.display = on ? '' : 'none'; }

    _getSectionRoot() {
      if (!this._sectionRoot) {
        this._sectionRoot = this.closest?.('[id^="shopify-section-"]') || document;
      }
      return this._sectionRoot;
    }
     /* ---------- Bundle SOD read from DOM ---------- */
    _readBundleSodFromDom() {
      // Find the selected card in the provided panel (supports .bundle-card or .box)
      const root = this._getSectionRoot(this) || document;
      const panel = root.querySelector(this.bundlePanelSel);
      if (!panel) return [];

      const card = panel.querySelector('.bundle-radio:checked')?.closest('.bundle-card, .box')
                || panel.querySelector('.bundle-card.is-selected, .box.is-selected')
                || panel.querySelector('.bundle-card, .box');

      if (!card) return [];

      try {
        const raw = card.getAttribute('data-sod') || '[]';
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (_e) {
        return [];
      }
    }
    
    _readBundleTitleFromDom() {
      const root  = this._getSectionRoot(this) || document;
      const panel = root.querySelector('#tab1 .bundle-wrapper');
      if (!panel) return '';
      const card = panel.querySelector('.bundle-radio:checked')?.closest('.bundle-card, .box')
              || panel.querySelector('.bundle-card.is-selected, .box.is-selected')
              || panel.querySelector('.bundle-card, .box');
      if (!card) return '';
      return card.getAttribute('data-title') || card.querySelector('.h_16')?.textContent?.trim() || '';
    }

    _nearestVariants() {
      // Fallback: nearest preceding <glory-variants> sibling or in the same section
      let el = this.previousElementSibling;
      while (el) {
        if (el.tagName && el.tagName.toLowerCase() === 'glory-variants') return el;
        el = el.previousElementSibling;
      }
      return document.querySelector('glory-variants');
    }

    _escape(s) { return String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }


    _money(cents) {
      const n = Number(cents) || 0;
      try {
        // If theme exposes formatMoney + format string, use it
        const fmt = window.themeVariables?.settings?.currencyCodeEnabled
          ? window.themeVariables?.settings?.moneyWithCurrencyFormat
          : window.themeVariables?.settings?.moneyFormat;
        if (typeof window.formatMoney === 'function' && fmt) {
          return window.formatMoney(n, fmt);
        }
      } catch(_e) {}
      const v = (n / 100);
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(v);
    }
  }
  window.customElements.define("glory-sod", GlorySOD);

  var InteractiveImage = class extends CustomHTMLElement {
    // images component here
    connectedCallback() {
      this.forSel   = this.getAttribute('for') || null;
      this.$section = this.closest('[id^="shopify-section-"]') || document;

      // Core nodes
      this.$battery0 = this.querySelector('[data-battery-0]');
      this.$battery1 = this.querySelector('[data-battery-1]');

      // Qty badges
      this.$qtyBatt    = this.querySelector('[data-qty-batt]');
      this.$qtyPanel   = this.querySelector('[data-qty-panel]');
      this.$qtyBracket = this.querySelector('[data-qty-bracket]');

      // Maps (keys lowercased): "200w-6", "1".."3"
      this.solarMap   = this._buildKeyedMap('.solar-panel-wrapper .component.solar-panel', 'data-panel-');
      // this.bracketMap = this._buildKeyedMap('.bracket-wrapper [data-bracket-1], .bracket-wrapper [data-bracket-2], .bracket-wrapper [data-bracket-3]', 'data-bracket-');
      this.bracketMap = this._buildKeyedMap('.bracket-wrapper img', 'data-bracket-');
      this.accessMap  = this._buildKeyedMap('.accessories-wrapper [data-access-1], .accessories-wrapper [data-access-2], .accessories-wrapper [data-access-3]', 'data-access-');

      // Bind to <glory-variants>
      this._onChange = (e) => this._applyState(e.detail || {});
      this._wireGV();

      // Initial state (hide overlays, show base battery0)
      this._hideAllMap(this.solarMap);
      this._hideAllMap(this.bracketMap);
      this._hideAllMap(this.accessMap);
      this._showOnly([
        [this.$battery0, true],
        [this.$battery1, false],
      ]);

      // Hide qty badges until state arrives
      this._show(this.$qtyBatt, false);
      this._show(this.$qtyPanel, false);
      this._show(this.$qtyBracket, false);

      // Optimize Interactive images to load after all scripts loaded in.
      this._stateApplied = false;
      this._readyResolved = false;
      const imagesReady = this._waitForImagesStable(this);
      const stateReady = new Promise(res => {
        if (this._stateApplied) return res();

        this._resolveOnState = () => {
          if (this._readyResolved) return;
          res();
        };
      });

      Promise.all([imagesReady, stateReady]).then(() => {
        if (this._readyResolved) return;
        this._readyResolved = true;
        this._markReady();
      });
    }

    disconnectedCallback() {
      if (this.$gv && this._onChange) this.$gv.removeEventListener('glory:change', this._onChange);
      this._gvMO?.disconnect();
    }

    /* ---------------- Binding ---------------- */

    _wireGV() {
      const tryAttach = () => {
        const target = this.forSel
          ? this.$section.querySelector(this.forSel)
          : this.$section.querySelector('glory-variants');
        if (!target) return false;
        this.$gv = target;
        this.$gv.addEventListener('glory:change', this._onChange);
        // ask for current snapshot if supported
        this.$gv.dispatchEvent(new CustomEvent('glory:snapshot', { bubbles: true }));
        return true;
      };

      if (!tryAttach()) {
        this._gvMO = new MutationObserver(() => { tryAttach(); });
        this._gvMO.observe(this.$section, { childList: true, subtree: true });
      }
    }

    /* ---------------- Core logic ---------------- */

    _applyState(detail) {
      this._stateApplied = true;
      if (this._resolveOnState) {
        this._resolveOnState();
        this._resolveOnState = null;
      }
      const mode = (detail?.mode || 'custom').toLowerCase();

      // Normalize incoming values
      let panelWattRaw = (detail?.panel?.watt || '');                  // e.g. "200W", "200", " 200 w "
      let isLite = /lite/.test(detail?.panel?.watt.toLowerCase())
      let panelWatt    = this._normalizeWatt(panelWattRaw);            // -> "200w" | "285w" | ""
      let panelCount   = parseInt(String(detail?.panel?.count ?? 0), 10) || 0;
      let expansion    = parseInt(String(detail?.storage?.count ?? 0), 10) || 0;
      let prodIndex    = parseInt(String(detail?.prodIndex ?? 0), 10) || 0;
      let mountName    = (detail?.mountName || '').trim();
      const isAdjustable = detail.adjustable === 'after'? true: false ;

      if (mode === 'bundle') {
        const sod = Array.isArray(detail?.bundle?.sod) ? detail.bundle.sod : [];

        const byImg = (imgName) => sod.find(it =>
          String(it?.img_file || '').toLowerCase() === String(imgName || '').toLowerCase()
        );
        const q = (v) => {
          const n = parseInt(String(v ?? 0), 10);
          return Number.isFinite(n) && n > 0 ? n : 0;
        };

        // 1) Expansion battery: show battery1 iff 'expansion_1' exists with qty >= 1
        const expItem = byImg('expansion_1');
        const expQty  = q(expItem?.quantity);
        expansion = expQty; // 0 => battery0, >=1 => battery1

        // 2) Solar panels from img_file 'solar_200'
        const s200 = byImg('solar_200');
        const c200 = q(s200?.quantity);

        if (c200 > 0) {
          panelWatt  = '200w';
          panelCount = c200;
        } else {
          panelWatt  = '';
          panelCount = 0;
        }

        // 3) Brackets from 'bracket_1' | 'bracket_2' | 'bracket_3'
        const b1 = byImg('bracket_1'); const q1 = q(b1?.quantity);
        const b2 = byImg('bracket_2'); const q2 = q(b2?.quantity);
        const b3 = byImg('bracket_3'); const q3 = q(b3?.quantity);

        let chosenIdx = 0, chosenQty = 0;
        if (q1 > 0) { chosenIdx = 1; chosenQty = q1; }
        else if (q2 > 0) { chosenIdx = 2; chosenQty = q2; }
        else if (q3 > 0) { chosenIdx = 3; chosenQty = q3; }

        prodIndex = chosenIdx;
        // expose bracket qty for your qty badge logic
        if (!detail.brackets) detail.brackets = {};
        detail.brackets.count = chosenQty || undefined;

        // Clear mountName so "Without Bracket" regex won’t interfere for bundle
        mountName = '';
      }

      const hasSolar = panelCount > 0;

      // 1) Battery images + shrink w/ solar
      this._showOnly([
        [this.$battery0, expansion <= 0],
        [this.$battery1, expansion > 0],
      ]);

      [this.$battery0, this.$battery1].forEach(img => img && img.classList.remove('w-solar'));
      const visibleBattery = expansion > 0 ? this.$battery1 : this.$battery0;
      if (visibleBattery && hasSolar) visibleBattery.classList.add('w-solar');
      const batteryWrap = this.querySelector('.battery-wrapper');
      if (batteryWrap) batteryWrap.classList.toggle('w-solar', hasSolar);

      // 1a) Battery qty badge
      if (this.$qtyBatt) {
        if (expansion > 0) {
          this._setText(this.$qtyBatt, `2035Wh Erweiterungsakku x ${expansion}`);
          this._show(this.$qtyBatt, true);
        } else {
          this._show(this.$qtyBatt, false);
        }
      }

      // 2) Solar overlays (exactly one)
      this._hideAllMap(this.solarMap);
      let panelKey
      if(isLite){
        panelKey = `lite-${panelWatt}-${panelCount}`
      }else{
        panelKey = `${panelWatt}-${panelCount}`
      }

      const keyLC = (hasSolar && panelWatt) ? panelKey : '';
      let solarEl = keyLC ? this.solarMap.get(keyLC) : null;

      // Fallbacks for mismatched/missing watt labels, and for 10/12 counts
      if (!solarEl && hasSolar) {
        const candidates = [];
        for (const [k, node] of this.solarMap.entries()) {
          if (k.endsWith(`-${panelCount}`)) candidates.push([k, node]);
        }
        if (candidates.length === 1) {
          solarEl = candidates[0][1];
        } else if (candidates.length > 1) {
          const want = panelWatt || '200w';
          const exact = candidates.find(([k]) => k.startsWith(want));
          solarEl = (exact || candidates[0])[1];
        }
      }

      if (solarEl) this._show(solarEl, true);

      // 2a) Panel qty badge
      if (this.$qtyPanel) {
        if (hasSolar) {
          const wattTxt = (panelWatt || '').toUpperCase(); // "200W"
          this._setText(this.$qtyPanel, `${wattTxt} Solarpanel x ${panelCount}`);
          this._show(this.$qtyPanel, true);
        } else {
          this._show(this.$qtyPanel, false);
        }
      }

      // 3) Brackets: only show when solar exists, and not "Without Bracket"
      this._hideAllMap(this.bracketMap);
      const noBracket =
        /without\s+bracket/i.test(mountName || '') ||
        /ohne\s+halterung/i.test(mountName || ''); // DE support

      if (hasSolar && !noBracket && (prodIndex === 1 || prodIndex === 2 || prodIndex === 3)) {
        let brEl
        if(isLite){
          brEl = this.bracketMap.get("lite");
        }else{
          brEl = this.bracketMap.get(String(prodIndex));
          if( prodIndex == 2 && isAdjustable){
            brEl = this.bracketMap.get(String(4));
          }
        }
        if (brEl) this._show(brEl, true);
      }

      // 3a) Bracket qty badge (also requires solar)
      if (this.$qtyBracket) {
        if (hasSolar && !noBracket && (prodIndex === 1 || prodIndex === 2 || prodIndex === 3)) {
          const bracketQty = parseInt(String(detail?.brackets?.count ?? panelCount ?? 0), 10) || 0;
          if (bracketQty > 0) {
            this._setText(this.$qtyBracket, `x ${bracketQty}`);
            this._show(this.$qtyBracket, true);
          } else {
            this._show(this.$qtyBracket, false);
          }
        } else {
          this._show(this.$qtyBracket, false);
        }
      }

      // Clear existing accessories wrapper content first
      const accessoriesWrapper = this.querySelector('.accessories-wrapper');
      if (accessoriesWrapper) {
        accessoriesWrapper.innerHTML = '';
      }

      const addons = (detail?.prices?.lines?.addons?.items || detail?.addons || []).filter(Boolean);

      // Create and append accessory images dynamically based on selected add-ons
      addons.forEach((addon, index) => {
        // Find the image source from the addon data
        let imgSrc = '';
        
        // Check if we have the product card HTML structure with image
        if (addon.img_src) {
          // Use the img_src property if available
          imgSrc = `${addon.img_src}`;
        } else if (addon.image) {
          // Fallback to image property
          imgSrc = addon.image;
        } else if (addon.handle) {
          // Generate image URL from product handle (common pattern)
          imgSrc = `/cdn/shop/files/${addon.handle}.png`;
        }
        
        // If we found an image source, create and append the image element
        if (imgSrc && accessoriesWrapper) {
          const img = document.createElement('img');
          img.className = 'access-img';
          img.setAttribute('data-access', index + 1);
          img.src = imgSrc;
          img.loading = 'lazy';
          img.alt = addon.title || addon.name || 'Accessory';
          
          accessoriesWrapper.appendChild(img);
        }
      });

      // If no accessories found, you might want to show a placeholder or hide the wrapper
      if (accessoriesWrapper && accessoriesWrapper.children.length === 0) {
        accessoriesWrapper.style.display = 'none';
      } else if (accessoriesWrapper) {
        accessoriesWrapper.style.display = '';
      }
    }

    /* ---------------- Helpers ---------------- */

    _normalizeWatt(watt) {
      // "200W", " 200 w ", "200" -> "200w"
      const n = String(watt || '').toLowerCase().replace(/\s+/g, '');
      const m = n.match(/(\d{2,3})/);
      return m ? `${m[1]}w` : '';
    }

    _buildKeyedMap(selector, dataPrefix) {
      const map = new Map();
      const nodes = this.querySelectorAll(selector);
      const pfx = String(dataPrefix).toLowerCase(); // attribute names are lowercase in DOM

      nodes.forEach(el => {
        const names = el.getAttributeNames ? el.getAttributeNames() : [];
        for (const n of names) {
          const nn = n.toLowerCase();
          if (nn.startsWith(pfx)) {
            const key = nn.slice(pfx.length); // e.g. "200w-6", "1"
            map.set(key, el);
            break;
          }
        }
      });
      return map;
    }

    _show(el, on) { if (el) el.style.display = on ? '' : 'none'; }
    _hideAllMap(map) { map.forEach(el => this._show(el, false)); }
    _showOnly(pairs) { pairs.forEach(([el, on]) => this._show(el, !!on)); }
    _setText(el, text) { if (el && el.textContent !== String(text)) el.textContent = String(text); }
    _waitForImagesStable(root, {
      selector = 'img',     
      settleMs = 500,       
      timeoutMs = 4000      
    } = {}) {
      const isDone = (img) => img.complete && img.naturalWidth >= 0;

      const trackImg = (img) => {
        if (!img || img.tagName !== 'IMG') return Promise.resolve();
        if (isDone(img)) return Promise.resolve();

        // If browser supports decode(), it’s more reliable than just load event
        if (img.decode) {
          return img.decode().catch(() => {});
        }

        return new Promise((res) => {
          img.addEventListener('load',  res, { once: true });
          img.addEventListener('error', res, { once: true });
        });
      };

      return new Promise((resolve) => {
        let settledTimer = null;
        let timeoutTimer = null;

        const collect = () => [...root.querySelectorAll(selector)];

        const finishWhenStable = async () => {
          clearTimeout(settledTimer);
          settledTimer = setTimeout(async () => {
            const imgs = collect();

            // IMPORTANT: don’t wait for lazy images that likely won’t load yet
            const activeImgs = imgs.filter(img => (img.getAttribute('loading') || '').toLowerCase() !== 'lazy');

            await Promise.all(activeImgs.map(trackImg));
            cleanup();
            resolve();
          }, settleMs);
        };

        const mo = new MutationObserver(() => finishWhenStable());
        mo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });

        const cleanup = () => {
          mo.disconnect();
          clearTimeout(settledTimer);
          clearTimeout(timeoutTimer);
        };

        timeoutTimer = setTimeout(() => { cleanup(); resolve(); }, timeoutMs);

        // initial run
        finishWhenStable();
      });
    }

    _markReady() {
      this.classList.add('is-ready');
      const content = this.querySelector('[data-content]');
      if (content) content.hidden = false;
    }
  };
  window.customElements.define("interactive-image", InteractiveImage);

})();

